"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ContentScroll_1 = require("./ContentScroll");
exports.default = ContentScroll_1.ContentScroll;
